export default function({ channel, uploadFiles, quillRef }) {
  const handleImage = async () => {
    const input = document.createElement('input')

    input.setAttribute('type', 'file')
    input.setAttribute('accept', 'image/*')
    input.click()

    const onUploadFile = async ({ file }) => {
      const data = await uploadFiles({ file })

      const editor = quillRef.getEditor()
      const unprivilegedEditor = quillRef.makeUnprivilegedEditor(editor)
      const range = unprivilegedEditor.getSelection()

      editor.insertEmbed(range.index, 'image', data.attachments[0].url)
    }

    input.onchange = async () => onUploadFile({ file: input.files[0] })
  }

  switch (channel) {
    case 'chatmail':
      return (
        {
          modules: {
            toolbar: {
              container: [
                [{ header: [1, 2, false] }],
                ['bold', 'italic', 'underline', 'strike', 'blockquote', 'image', 'link'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                ['clean']
              ],
              handlers: {
                image: handleImage
              }
            }
          },
          formats: ['header', 'bold', 'italic', 'underline', 'strike', 'blockquote', 'list', 'image', 'link']
        }
      )
    default:
      return (
        {
          modules: {
            toolbar: []
          },
          formats: []
        }
      )
  }
}
